"use client";

import React, { useState } from "react";
import axios from "axios";

const FormComponent: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCategory(e.target.value);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(false);

    // Datos que se enviarán al servidor
    const formData = {
      name,
      phone,
      category,
      email,
      message,
    };

    try {
      // Enviar datos a través de Axios
      const response = await axios.post(
        "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/form",
        formData
      );
      // Si el envío es exitoso
      if (response.status === 200) {
        setSuccess(true);
        // Limpiar los campos después de enviar
        setName("");
        setPhone("");
        setCategory("");
        setEmail("");
        setMessage("");

        // Ocultar el mensaje de éxito después de 30 segundos
        setTimeout(() => {
          setSuccess(false);
        }, 30000);
      }
    } catch (err) {
      // Si hay un error en el envío
      setError("Hubo un error al enviar el formulario. Inténtalo de nuevo.");
      
      // Ocultar el mensaje de error después de 30 segundos
      setTimeout(() => {
        setError(null);
      }, 30000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="request-a-visit-area ptb-100"
        style={{
          backgroundImage: `url(/images/contacto_ubicacion.webp)`,
        }}
      >
        <div className="container">
          <div className="request-a-visit-form">
            <h2>Contacto</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="*Nombre"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="*Celular"
                  value={phone}
                  onChange={handlePhoneChange}
                />
              </div>
              <div className="form-group">
                <select
                  className="form-select"
                  value={category}
                  onChange={handleCategoryChange}
                >
                  <option value="Acueductos">Acueductos</option>
                  <option value="Agroquímicos">Agroquímicos</option>
                  <option value="Alimentos">Alimentos</option>
                  <option value="Avícola">Avícola</option>
                  <option value="Curtiembres">Curtiembres</option>
                  <option value="Farmacéutica">Farmacéutica</option>
                  <option value="Laboratorio">Laboratorio</option>
                  <option value="Limpieza">Limpieza</option>
                  <option value="Petróleo">Petróleo</option>
                  <option value="Piscina Recreativa">Piscina Recreativa</option>
                  <option value="Porcícola">Porcícola</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="*Email"
                  value={email}
                  onChange={handleEmailChange}
                />
              </div>

              <div className="form-group">
                <textarea
                  cols={30}
                  rows={4}
                  placeholder="Mensaje"
                  value={message}
                  onChange={handleMessageChange}
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn-style-one red-light-color"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Enviando..." : "Enviar"}
              </button>
            </form>

            {error && <p className="error-message">{error}</p>}
            {success && <p className="success-message">¡Formulario enviado con éxito!</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
